module.exports = __webpack_public_path__ + "static/media/coinbase.a8b05c07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/exchanges/coinbase.svg
// module id = 100
// module chunks = 0